package com.example.mystybag.common.logic

import com.example.mystybag.common.resources.SR
import com.example.mystybag.communication.common.CommonCommands.sendGetCountries
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.extensions.asCountryImageLink
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.common.model.ChooseCountryUIState
import com.example.mystybag.common.model.CountryVisualModel
import com.example.mystybag.sharedmodels.UtilsCurrenciesAndCountriesDefines
import com.example.mystybag.sharedmodels.common.responseModels.CountryModel
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.toImmutableList

class ChooseCountryViewModel(
    context                         : AppContext,
    private val countriesType       : Int,
    private val selectedCountry     : List<CountryModel>    = listOf(),
    private val excludedCountries   : List<String>          = listOf(),
    private val showSearchRightAway : Boolean               = false,
    private val onSuccess           : (List<CountryModel>) -> Unit
): ChildViewModel<Unit>(context, Unit) {

    private var countriesList       = listOf<CountryModel>()
    private var visualList          : ImmutableList<CountryVisualModel> = persistentListOf()

    private val isMultiSelection    = false

    val uiData                      = ChooseCountryUIState()

    override fun onCreate() {
        navControls.title               = sharedString(SR.strings.choose_country_region)

        getCountries()
    }

    override fun onSearchTextChanged(search: String) {
        (if (search.isEmpty()) visualList else visualList.filter {
            it.name.contains(search, ignoreCase = true)
        }.toImmutableList()).also { searchList ->
            uiData.countries.value    = searchList
            uiData.showNoResult.value = search.isNotEmpty() && searchList.isEmpty()
        }
    }

    fun onCountryClicked(country: CountryVisualModel) {
        if (isMultiSelection) {
            countriesList.find { it.isoAlpha3 == country.isoAlpha3 }?.apply { isSelected = !isSelected }
            countriesList.filter { it.isSelected }.also { list ->
                uiData.selectedCountries.value = list.map { model ->
                    CountryVisualModel(
                        isoAlpha3 = model.isoAlpha3,
                        name      = model.name
                    )
                }.toImmutableList()
                uiData.showDoneButton.value = true
            }
        }
        else {
            countriesList.find { it.isoAlpha3 == country.isoAlpha3 }?.also { selected ->
                hideKeyboard()
                goBack()
                onSuccess(listOf(selected))
            }
        }
    }

    fun onDoneButtonClicked() {
        hideKeyboard()
        goBack()
        onSuccess(countriesList.filter { it.isSelected })
    }

    private fun getCountries() {
        commandBlock(showProgress = false, hideProgress = false) {
            sendGetCountries()
                .onResponse(
                    success = { response ->
                        response.countriesList?.also { countries ->

                            countriesList = countries.filterNot {
                                excludedCountries.contains(it.isoAlpha3)
                            }

                            val selectedVisualList = selectedCountry.map { selected ->
                                countriesList.find { it.isoAlpha3 == selected.isoAlpha3 }?.isSelected = true
                                CountryVisualModel(
                                    isoAlpha3 = selected.isoAlpha3,
                                    name      = selected.name,
                                    imageLink = selected.isoAlpha3.asCountryImageLink,
                                    isChecked = true
                                )
                            }

                            visualList = countriesList.map {
                                CountryVisualModel(
                                    isoAlpha3 = it.isoAlpha3,
                                    name      = it.name,
                                    imageLink = it.isoAlpha3.asCountryImageLink,
                                    isChecked = it.isSelected
                                )
                            }.toImmutableList()
                             .also {
                                uiData.countries.value          = it
                                uiData.selectedCountries.value  = selectedVisualList.toImmutableList()
                                uiData.isLoading.value          = false
                            }

                            uiThread {
                                searchControls.openSearch = showSearchRightAway
                            }
                        }
                    },
                    baseError = {
                        uiData.isLoading.value = false
                    }
                )
        }
    }

    private fun getCountryIso3ByIso2(countryIso2: String): String {
        val searchFor = countryIso2.trim()
        UtilsCurrenciesAndCountriesDefines.ALL_COUNTRY_CODES.forEach {
            val chunks = it.split(",")
            if (chunks[1] == searchFor)
                return chunks[2]
        }
        return ""
    }
}